import React, { useEffect, useState, useRef, useCallback } from "react";
import { Outlet, Link } from "react-router-dom";
import logo from "../../Assets/image/logo.png";
import Bar1 from "../navigationbar/navigationbar1";
import Footer from "../../view/pages/footer/footer";

const HeaderLayout = () => {
    const [isVisible, setIsVisible] = useState(true);
    const lastScrollY = useRef(0);

    const handleScroll = useCallback(() => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY.current + 10) {
            setIsVisible(false); // Hide on scroll down (with threshold for smoother behavior)
        } else if (currentScrollY < lastScrollY.current - 10) {
            setIsVisible(true); // Show on scroll up
        }

        lastScrollY.current = currentScrollY;
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]); // Stable callback reference prevents infinite loops

    return (
        <>
            {/* AppA HEADER */}
            <div className={`AppA ${isVisible ? "visible" : "hidden"}`}>
                <div className="mylogo">
                    <div className="logo-container">
                        <Link to="/">
                            <img src={logo} alt="Logo" />
                        </Link>
                    </div>
                </div>

                <div className="bar-container">
                    <Bar1 />
                </div>
            </div>

            {/* Page Content */}
            <Outlet />

            {/* FOOTER */}
            <Footer />
        </>
    );
};

export default HeaderLayout;
